<div id="clockInOutPage" class="container" style="padding-top: 50px;">
    <div class="alert alert-danger">
        <span>You are not authorized to clock in. Redirecting back to login page...</span>
    </div>
</div>
